import { Loading } from "element-ui";

let loading; // 保存 loading 实例
let needLoadingRequestCount = 0; // 追踪请求数量
let loadingTimer; // 新增：loading 计时器

// 开启 loading
function startLoading(text, target) {
  // console.log("启动 loading，提示文本:", text); // 调试日志
  loading = Loading.service({
    lock: true,
    text: text ? text : "加载中,请稍候……", // 如果没有指定文本，则使用默认提示
    background: "rgba(0, 0, 0,0.7)", // 设置背景色
    target: target ? target : document.body, // 如果没有指定目标，则默认应用到整个页面
    customClass: "createLoading", // 自定义 class
    spinner: "el-icon-loading", // 图标
  });

  // 新增：设置 60 秒超时
  loadingTimer = setTimeout(() => {
    if (loading) {
      needLoadingRequestCount = 0; // 重置计数
      endLoading();
      // console.warn("Loading timeout after 30 seconds");
    }
  }, 60000000);
}

// 关闭 loading
function endLoading() {
  if (loading) {
    clearTimeout(loadingTimer); // 新增：清除计时器
    loading.close();
    loading = null; // 清空 loading 实例
  }
}

// 显示全屏 loading
export function showFullScreenLoading(text, target) {
  // console.log(
  //   "调用 showFullScreenLoading 前请求计数:",
  //   needLoadingRequestCount
  // ); // 调试日志
  if (needLoadingRequestCount === 0) {
    startLoading(text, target);
  }
  needLoadingRequestCount++;
  // console.log(
  //   "调用 showFullScreenLoading 后请求计数:",
  //   needLoadingRequestCount
  // ); // 调试日志
}

// 尝试隐藏全屏 loading
export function tryHideFullScreenLoading() {
  // console.log(
  //   "调用 tryHideFullScreenLoading 前请求计数:",
  //   needLoadingRequestCount
  // ); // 调试日志
  if (needLoadingRequestCount <= 0) return; // 如果计数已为0，直接返回
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
  // console.log(
  //   "调用 tryHideFullScreenLoading 后请求计数:",
  //   needLoadingRequestCount
  // ); // 调试日志
}
